import { render, staticRenderFns } from "./TestingCenterConsentPage.vue?vue&type=template&id=306f92ad&"
import script from "./TestingCenterConsentPage.vue?vue&type=script&lang=js&"
export * from "./TestingCenterConsentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports